import {raise} from '@yandex-delivery/utils'

import type {Message, Tariff, TariffData, TariffsList} from '../../../model/tariffs'
import type {TariffItem, TariffListResponse, TariffsMessage} from '../../../repo/tariffs'

export const toTariffsListBody = (zone: string) => ({zone_name: zone})

const toTariff = ({name, ...item}: TariffItem): Tariff => ({...item, title: name})
const toMessage = (message: TariffsMessage): Message => ({...message})

/**@deprecated  CARGODEV-47716*/
export function toTariffData(tariff?: string) {
  return function _toTariffData({
    tariffs: responseTariffs,
    messages: responseMessages,
  }: TariffListResponse): TariffData {
    const tariffs = responseTariffs.map(toTariff)
    const currentTariff = tariffs.find(({id}) => id === tariff)
    const tabItems = tariffs.map(({id, title}) => ({label: title, value: id}))

    return {
      tariffs,
      defaultTariff: tariffs[0] || raise('Tariffs list is empty!'),
      messages: responseMessages.map(toMessage),
      currentTariff,
      tabItems,
    }
  }
}

export function toTariffsList({tariffs: responseTariffs, messages: responseMessages}: TariffListResponse): TariffsList {
  const tariffs = responseTariffs.map(toTariff)
  const getCurrentTariff = (tariffId: string) =>
    tariffs.find(({id}) => id === tariffId) || raise(`Unknown tariff: ${tariffId}`)
  const tabItems = tariffs.map(({id, title}) => ({label: title, value: id}))

  return {
    tariffs,
    messages: responseMessages.map(toMessage),
    defaultTariff: toTariff(responseTariffs[0] || raise('Tariffs list is empty!')),
    getCurrentTariff,
    tabItems,
  }
}
